import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Cppsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Coperator(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  

return(
    <div>
       
      <Sides/>
       <Helmet>
 
 <title>C++ Operator tutorial For Beginners</title>
 <meta name="description" content="C++ Operator tutorial for beginners.Operators in C++ are used special symbols which perform any type of operations.CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,C++ Operator tutorial for beginners,programming language tutorial for begineers,learn code in free,c++ programming tutorial for beginners,learn code in free online,cpp operator,c++ operators,c++ operator precedence,logical operators in c++,cpp operator order,modulo operator in cpp,or operator in c++,cpp operator or,and operator in c++" />
 <link rel="canonical" href="https://www.codeexampler.com/cpp-operator" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">C++ Operator</h1>
    <div className="first">
        <a href="/cpp-literal">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-control-structure">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">What is an Operator in C++:</h2>
    <p className="mt-4 para">Operators in C++ use special symbols which perform any operations.<br/>
or<br/>
The C++ and operator is a particular symbol use in the expression.
</p>


<h2 className='headings'>Operator in C++ Syntax code</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-10">106</span>
            <span className="qwerty-5"> / </span>
            <span className="qwerty-10">8</span>
            <span className="qwerty-5"> % </span>
            <span className="qwerty-10">40</span>
             {"\n"}   {"\n"}
          </code>
        </pre>
      </div>

      <h2 className='headings'>Answer-</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-2">(</span>
            <span className="qwerty-5"> + </span>
            <span className="qwerty-2">- /</span>
            <span className="qwerty-5"> %</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-5"> this is an  </span>
            <span className="qwerty-10">operator</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>




<h2 className='headings'>Operator in C++ Syntax code</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-10">int</span>
            <span className="qwerty-6"> c </span>
            <span className="qwerty-10">= </span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-10">+ </span>
            <span className="qwerty-5"> b</span>
             {"\n"}   {"\n"}
          </code>
        </pre>
      </div>

      <h2 className='headings'>Answer:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-2">(</span>
            <span className="qwerty-5">= </span>
            <span className="qwerty-2">, </span>
            <span className="qwerty-5">+</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-6"> are an </span>
            <span className="qwerty-10">operator</span>
            {"\n"}
            <span className="qwerty-2">(</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">,</span>
            <span className="qwerty-5"> b</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-6"> are an </span>
            <span className="qwerty-10">operands</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className='headings'>Operator in C++ Syntax code</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-6">a</span>
            <span className="qwerty-2"> = </span>
            <span className="qwerty-10">b </span>
            <span className="qwerty-2">+ </span>
            <span className="qwerty-10">c </span>
            <span className="qwerty-2">+ </span>
            <span className="qwerty-10">d</span>
            <span className="qwerty-2">;</span>
             {"\n"}   {"\n"}
          </code>
        </pre>
      </div>

      <h2 className='headings'>Output-</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-2">(</span>
            <span className="qwerty-5">+</span>
            <span className="qwerty-2">, </span>
            <span className="qwerty-5">=</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-6"> there are 2 </span>
            <span className="qwerty-10">operators</span>
            {"\n"}
            <span className="qwerty-2">(</span>
            <span className="qwerty-5">b</span>
            <span className="qwerty-2">,</span>
            <span className="qwerty-5"> c</span>
            <span className="qwerty-2">, </span>
            <span className="qwerty-5">d</span>
            <span className="qwerty-2">)</span>
            <span className="qwerty-6"> there are 3 </span>
            <span className="qwerty-10">operands</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="mt-4 mh2">1, Arithmetic operator:</h2>
<h3 className="mt-4 mh3">+ add<br/>
-Sub<br/>
Multiply<br/>
/ division<br/>
% modules<br/>
++ increment<br/>
-- decrement<br/>
</h3>


<h2 className='headings'>C++ Operator Example code:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-11"> int </span>
            <span className="qwerty-2">main</span>
              <span className="qwerty-3">( )</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-10">int </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty">, </span>
            <span className="qwerty-3">b</span>
            <span className="qwerty">, </span>
            <span className="qwerty-3">c</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">a </span>
            <span className="qwerty-4">= </span>
            <span className="qwerty-5">8</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">b </span>
            <span className="qwerty">= </span>
            <span className="qwerty-4">4</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">c</span>
            <span className="qwerty"> = </span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-6"> + </span>
            <span className="qwerty-3">b</span>
            <span className="qwerty-3">;</span>
            {"\n"}
              <span className="qwerty-10">cout </span>
            <span className="qwerty">&#60;&#60; </span>
            <span className="qwerty-5">c</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">return</span>
              <span className="qwerty-2"> 0</span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"} 
              <span className="qwerty">12</span>
              {"\n"}{"\n"}</code></pre>
        </div>
      </div>



<h2 className='headings'>C++ Operator Example code:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
            <span className="qwerty-6">C</span>
            <span className="qwerty-5"> = </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-2">- </span>
            <span className="qwerty-10">b</span>
            <span className="qwerty-5"> ;</span>
            {"\n"}
            <span className="qwerty-6">C</span>
            <span className="qwerty-5"> = </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-2">+ </span>
            <span className="qwerty-10">b</span>
            <span className="qwerty-5"> ;</span>
            {"\n"}
            <span className="qwerty-6">C</span>
            <span className="qwerty-5"> = </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-2">* </span>
            <span className="qwerty-10">b</span>
            <span className="qwerty-5"> ;</span>
            {"\n"}
            <span className="qwerty-6">C</span>
            <span className="qwerty-5"> = </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-2">/ </span>
            <span className="qwerty-10">b</span>
            <span className="qwerty-5"> ;</span>
            {"\n"}
            <span className="qwerty-6">C</span>
            <span className="qwerty-5"> = </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-2">% </span>
            <span className="qwerty-10">b</span>
            <span className="qwerty-5"> ;</span>
            {"\n"}
            <span className="qwerty-6">C</span>
            <span className="qwerty-5"> = </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-2">++</span>
            <span className="qwerty-5"> ; </span>
            <span className="qwerty-4">or </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-2">--</span>
            <span className="qwerty-5"> ;</span>
            {"\n"}
            <span className="qwerty-6">C</span>
            <span className="qwerty-5"> = </span>
            <span className="qwerty-10">b </span>
            <span className="qwerty-2">++</span>
            <span className="qwerty-5"> ; </span>
            <span className="qwerty-4">or </span>
            <span className="qwerty-10">b </span>
            <span className="qwerty-2">--</span>
            <span className="qwerty-5"> ;</span>
             {"\n"}   {"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">2,Relational operator:</h2>
<h3 className="mt-4 mh3"> Greater than  <br/>
&#60;less than <br/>
&#62;=greater than or equal to<br/>
&#60;= -less than or equal to<br/>
!= - not equal to<br/>
== -equal to<br/>
</h3>

<h2 className="mt-4 mh2">C++ Relational Operator Example</h2>


<h2 className='headings'>Q-Write a program which no is Greater than b/w a and b in C++?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-11"> int </span>
            <span className="qwerty-2">main</span>
              <span className="qwerty-3">( )</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-11">int </span>
            <span className="qwerty-4">a</span>
            <span className="qwerty">, </span>
            <span className="qwerty-4">b</span>
            <span className="qwerty">, </span>
            <span className="qwerty-4">c</span>
            <span className="qwerty">;</span>
            {"\n"}
            <span className="qwerty-10">a </span>
            <span className="qwerty">= </span>
            <span className="qwerty-4">10</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">b </span>
            <span className="qwerty">= </span>
            <span className="qwerty-4">20</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty">if </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-3">&#60; </span>
            <span className="qwerty-5">b</span>
            <span className="qwerty-3">)</span>
            {"\n"}
              <span className="qwerty-10">cout </span>
            <span className="qwerty">&#60;&#60; "</span>
            <span className="qwerty-5">b</span>
            <span className="qwerty"> is </span>
              <span className="qwerty-10">greater</span>
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-4">return</span>
              <span className="qwerty-2"> 0</span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"} 
              <span className="qwerty-4">b</span>
              <span className="qwerty"> is </span>
              <span className="qwerty-10">greater</span>
              {"\n"}{"\n"}</code></pre>
        </div>
      </div>


<h2 className="mt-4 mh2">C++ Relational Operator Example:</h2>


<h2 className='headings'>Q-Write a program check no is equal in C++?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-11"> int </span>
            <span className="qwerty-2">main</span>
              <span className="qwerty-3">( )</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-11">int </span>
            <span className="qwerty-4">a</span>
            <span className="qwerty">, </span>
            <span className="qwerty-4">b</span>
            <span className="qwerty">;</span>
            {"\n"}
            <span className="qwerty-10">a </span>
            <span className="qwerty">= </span>
            <span className="qwerty-4">20</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">b </span>
            <span className="qwerty">= </span>
            <span className="qwerty-4">20</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty">if </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-3">&#60; </span>
            <span className="qwerty">= </span>
            <span className="qwerty-5">b</span>
            <span className="qwerty-3">)</span>
            {"\n"}
              <span className="qwerty-10">cout </span>
            <span className="qwerty">&#60;&#60; "</span>
            <span className="qwerty-5">both</span>
            <span className="qwerty"> are </span>
              <span className="qwerty-10">equal</span>
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-4">return</span>
              <span className="qwerty-2"> 0</span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"} 
              <span className="qwerty-4">both</span>
              <span className="qwerty"> are </span>
              <span className="qwerty-10">equal</span>
              {"\n"}{"\n"}</code></pre>
        </div>
      </div>


<h2 className="mt-4 mh2">3,Logic operator:</h2>
<h3 className="mt-4 mh2">And  &#38;&#38;<br/>
Or   &#124;&#124;<br/>
Not&#33;
</h3>



<h2 className='headings'>Q-Write a program check no is equal?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-11"> int </span>
            <span className="qwerty-2">main</span>
              <span className="qwerty-3">( )</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-11">int </span>
            <span className="qwerty-4">a</span>
            <span className="qwerty">, </span>
            <span className="qwerty-4">b</span>
            <span className="qwerty">;</span>
            {"\n"}
            <span className="qwerty-10">a </span>
            <span className="qwerty">= </span>
            <span className="qwerty-4">20</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-10">b </span>
            <span className="qwerty">= </span>
            <span className="qwerty-4">20</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty">if </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-3">&#38;</span>
            <span className="qwerty">&#38; </span>
            <span className="qwerty-5">b</span>
            <span className="qwerty-3">)</span>
            {"\n"}
              <span className="qwerty-10">cout </span>
            <span className="qwerty">&#60;&#60; "</span>
            <span className="qwerty-6">both</span>
            <span className="qwerty"> are </span>
              <span className="qwerty-10">equal</span>
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-4">return</span>
              <span className="qwerty-2"> 0</span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"} 
              <span className="qwerty-6">both</span>
              <span className="qwerty"> are </span>
              <span className="qwerty-10">equal</span>
              {"\n"}{"\n"}</code></pre>
        </div>
      </div>


<h2 className="mt-4 mh2">4, Bitwise operator:</h2>
<h3 className="mt-4 mh2">
&#62;&#62; - right shift<br/>
    &#60;&#60; - left shift<br/>
^ xor<br/>
~ B Not<br/>
</h3>

<h2 className="mt-4 mh2">5, Assignment operator:</h2>
<h3 className="mt-4 mh3">=<br/>
+=<br/>
-=<br/>
*=<br/>
/=<br/>
%=<br/>
&#47;&#47;=<br/>
**=<br/>
&#38;=<br/>
&#60;&#60;=<br/>
&#62;&#62;=<br/>
^=<br/>
</h3>

<h2 className="mt-4 mh2">6, Identifier operator in C++:</h2>


<h2 className='headings'>Q-Write a program multiply a no Identifier in C++ Operator?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-11"> int </span>
            <span className="qwerty-2">main</span>
              <span className="qwerty-3">( )</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-11">int </span>
            <span className="qwerty-5">a</span>
            <span className="qwerty">;</span>
            {"\n"} 
            <span className="qwerty-5">a</span>
            <span className="qwerty-4"> = </span>
            <span className="qwerty-10">5</span>
            <span className="qwerty">;</span>
            {"\n"} 
            <span className="qwerty-5">a </span>
            <span className="qwerty-4">= </span>
            <span className="qwerty-5">a</span>
            <span className="qwerty"> * </span>
            <span className="qwerty-10">4</span>
            <span className="qwerty">;</span>
            {"\n"}
            <span className="qwerty-10">OR</span>
            {"\n"}
            <span className="qwerty-5">a</span>
            <span className="qwerty-3">*</span>
            <span className="qwerty-5">= </span>
            <span className="qwerty-10">4</span>
            <span className="qwerty-3">;</span>
            {"\n"}
              <span className="qwerty-10">cout </span>
            <span className="qwerty">&#60;&#60; </span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">return</span>
              <span className="qwerty-10"> 0</span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"} 
              <span className="qwerty-4">20</span>
              {"\n"}{"\n"}</code></pre>
        </div>
      </div>

<h2 className="mt-4 mh2">7,The conditional operator (?:) in C++:
</h2>
<p className="mt-4 para">1, A conditional operator is known as a ternary operator.<br/>
2, The main point is that this Conditional operator consists of three operands.<br/>
</p>


<h2 className='headings'>C++ Conditional Operator Syntax Code:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
            <span className="qwerty-6">Variable</span>
            <span className="qwerty-4"> a </span>
            <span className="qwerty-10">= </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-10">expression</span>
            <span className="qwerty-2">) </span>
            <span className="qwerty-5">? </span>
            <span className="qwerty">true </span>
            <span className="qwerty-2">:</span>
            <span className="qwerty-3"> false</span>
           {"\n"} {"\n"}
           
          </code>
        </pre>
      </div>

<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/cpp-literal"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-control-structure"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

    </div></div>
)

}
export default Coperator;